import React from "react";
import Layout from "../components/Layout";
import { LockIcon } from "../assets/icons/Icons";
import "../assets/scss/components/permission-required.scss";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../contexts/UserContext";

const PermissionDenied = ({ allowedRoles, requiredPermissions }) => {
  const { t } = useTranslation();
  const { hasDynamicPermissions } = useUserContext();
  const showRoles = !hasDynamicPermissions() && allowedRoles;
  const renderPermissions = () => {
    if (!requiredPermissions) return null;

    return (
      <ul>
        {Object.entries(requiredPermissions).map(([key, value]) => (
          <li key={key}>
            <strong>{key}</strong>: {value}
          </li>
        ))}
      </ul>
    );
  };
  return (
    <Layout>
      <div className="permission-required">
        <div className="row">
          <div className="col-auto">
            <div className="permission-required__icon">
              <LockIcon />
            </div>
          </div>
          <div className="col">
            <div className="permission-required__content">
              <h2>{t("Permission Required")}</h2>
              <div>
                <p>
                  {t("You need the following privileges to access this page")}:
                </p>
                {showRoles && (
                  <p>
                    <strong>{allowedRoles.join(", ")}</strong>.
                  </p>
                )}
                {requiredPermissions && (
                  <div>
                    <strong>{t("Required Permissions")}:</strong>
                    {renderPermissions()}
                  </div>
                )}
                <p>
                  {t(
                    "If you believe this is a mistake, please reach out to your administrator for help."
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PermissionDenied;
